var map = {
  "./translation.json": "31801",
  "./portal.json": "89448",
  "./teams.json": "49256",
  "./homepage.json": "23978"
};
function webpackAsyncContext(req) {
  return Promise.resolve().then(function() {
    if(!__webpack_require__.o(map, req)) {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    }

    var id = map[req];
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10412;
module.exports = webpackAsyncContext;
